import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Share2($$anchor, $$props) {
	const iconNode = [
		["circle", { "cx": "18", "cy": "5", "r": "3" }],
		["circle", { "cx": "6", "cy": "12", "r": "3" }],
		["circle", { "cx": "18", "cy": "19", "r": "3" }],

		[
			"line",
			{ "x1": "8.59", "x2": "15.42", "y1": "13.51", "y2": "17.49" }
		],

		[
			"line",
			{ "x1": "15.41", "x2": "8.59", "y1": "6.51", "y2": "10.49" }
		]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiU2hhcmUyLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wiY2lyY2xlXCIsIHsgXCJjeFwiOiBcIjE4XCIsIFwiY3lcIjogXCI1XCIsIFwiclwiOiBcIjNcIiB9XSwgW1wiY2lyY2xlXCIsIHsgXCJjeFwiOiBcIjZcIiwgXCJjeVwiOiBcIjEyXCIsIFwiclwiOiBcIjNcIiB9XSwgW1wiY2lyY2xlXCIsIHsgXCJjeFwiOiBcIjE4XCIsIFwiY3lcIjogXCIxOVwiLCBcInJcIjogXCIzXCIgfV0sIFtcImxpbmVcIiwgeyBcIngxXCI6IFwiOC41OVwiLCBcIngyXCI6IFwiMTUuNDJcIiwgXCJ5MVwiOiBcIjEzLjUxXCIsIFwieTJcIjogXCIxNy40OVwiIH1dLCBbXCJsaW5lXCIsIHsgXCJ4MVwiOiBcIjE1LjQxXCIsIFwieDJcIjogXCI4LjU5XCIsIFwieTFcIjogXCI2LjUxXCIsIFwieTJcIjogXCIxMC40OVwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7a0RBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLFFBQVEsSUFBSSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUc7R0FBTSxRQUFRLElBQUksSUFBSSxFQUFFLEdBQUcsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxHQUFHO0dBQU0sUUFBUSxJQUFJLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRzs7O0dBQU0sTUFBTTtLQUFJLElBQUksRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxPQUFPOzs7O0dBQU0sTUFBTTtLQUFJLElBQUksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxPQUFPOzs7O0tBQ2xWLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9